import * as React from "react";
import { IconProps } from "./IconProps";

export const IconChevronDoubleLeft = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <g id="chevron double left">
          <path
            id="Icon (Stroke)"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.7071 7.29289C12.0976 7.68342 12.0976 8.31658 11.7071 8.70711L8.41421 12L11.7071 15.2929C12.0976 15.6834 12.0976 16.3166 11.7071 16.7071C11.3166 17.0976 10.6834 17.0976 10.2929 16.7071L6.29289 12.7071C5.90237 12.3166 5.90237 11.6834 6.29289 11.2929L10.2929 7.29289C10.6834 6.90237 11.3166 6.90237 11.7071 7.29289ZM18.7071 7.29289C19.0976 7.68342 19.0976 8.31658 18.7071 8.70711L15.4142 12L18.7071 15.2929C19.0976 15.6834 19.0976 16.3166 18.7071 16.7071C18.3166 17.0976 17.6834 17.0976 17.2929 16.7071L13.2929 12.7071C12.9024 12.3166 12.9024 11.6834 13.2929 11.2929L17.2929 7.29289C17.6834 6.90237 18.3166 6.90237 18.7071 7.29289Z"
            fill={color}
          />
        </g>
      </svg>
    );
  }
);
